// Combine env vars passed by Gitlab Runner,
// Docker etc during execution over build stage

export const env: Record<string, string> = {
  API_URL: process.env.API_URL,
  NODE_ENV: process.env.NODE_ENV,
  ATTACHMENT_SERVICE_URI: process.env.ATTACHMENT_SERVICE_URI,
  PDF_SERVICE_URI: process.env.PDF_SERVICE_URI,
  FROALA_EDITOR_KEY: process.env.FROALA_EDITOR_KEY,
  DOCS_URL: process.env.DOCS_URL,
  CDN_SERVICE_HOST: process.env.CDN_SERVICE_HOST,
  LOG_URL: process.env.LOG_URL,
  METRICS_URL: process.env.METRICS_URL,
  FEATURE_FLAGS: process.env.FEATURE_FLAGS,
  // @ts-ignore
  ...(window.env ?? null),
}; // Not secure way

export const isDev = process.env.NODE_ENV === 'development';

export const isProd = process.env.NODE_ENV === 'production';

export const isLocalURL = window.location.hostname === 'localhost';

export const isDevURL = window.location.hostname.includes('.dev.');

export const isStagingURL = window.location.hostname.includes('staging.');

export const isE2EURL = window.location.hostname.includes('web-e2e');
